import React, { useState } from 'react';
import { Container, Form, Button, Row, Col, Card, ListGroup } from 'react-bootstrap';
import axios from 'axios';

const ChirpTaskRequest = () => {
  const [requestText, setRequestText] = useState('');
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    setLoading(true);
    setResponse(null);
    setError(null);
    try {
      const res = await axios.post('https://www.chirptask.com/api/request', {
        request: requestText
      });
      setResponse(res.data);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    }
    setLoading(false);
  };

  return (
    <Container className="my-4">
      <h2>ChirpTask Request</h2>
      <Form>
        <Form.Group controlId="requestTextarea">
          <Form.Label>Enter your task request:</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={requestText}
            onChange={(e) => setRequestText(e.target.value)}
            placeholder="e.g. meet me near the hollywood sign and take 10 pictures of me"
          />
        </Form.Group>
        <Button className="mt-2" onClick={handleSubmit} disabled={loading}>
          {loading ? 'Processing...' : 'Request'}
        </Button>
      </Form>

      {error && <p className="text-danger mt-3">{error}</p>}

      {response && (
        <Card className="mt-4">
          <Card.Header><strong>Summary</strong></Card.Header>
          <Card.Body>
            <Card.Text>{response.summary}</Card.Text>
            <h5>Steps</h5>
            <ListGroup className="mb-3">
              {response.steps.map((step, index) => (
                <ListGroup.Item key={index}>
                  <strong>{step.description}</strong><br />
                  Tag: {step.tag} | Duration: {step.duration} min | Price: ${step.price}
                </ListGroup.Item>
              ))}
            </ListGroup>

            <h5>Actions</h5>
            <ListGroup className="mb-3">
              {response.actions.map((action, index) => (
                <ListGroup.Item key={index}>
                  <strong>{action['@type']}</strong>: {action.description}<br />
                  Duration: {action.duration} min | Difficulty: {action.difficulty}<br />
                  Tools Required: {action.toolsRequired.join(', ') || 'None'}
                </ListGroup.Item>
              ))}
            </ListGroup>

            <h5>Locations</h5>
            <ListGroup>
              {response.clean_locations.map((loc, index) => (
                <ListGroup.Item key={index}>
                  <strong>{loc.name}</strong><br />
                  {loc.address}<br />
                  GPS: ({loc.gps.latitude}, {loc.gps.longitude})
                </ListGroup.Item>
              ))}
            </ListGroup>

            <div className="mt-3">
              <strong>Total Cost:</strong> ${response.total} (Base: ${response.total_price}, Fees: ${response.total_fees})
            </div>
          </Card.Body>
        </Card>
      )}
    </Container>
  );
};

export default ChirpTaskRequest;